module.exports = __webpack_public_path__ + "img/Logotipo LS.a1f844af.png";